/**
 * use-compression-notification.ts
 * Écoute le store global de compression et affiche un toast Sonner
 * quand la compression se termine (utile quand l'utilisateur a navigué
 * hors de la page Médias pendant la compression).
 */

import { useEffect, useRef } from "react";
import { subscribeCompression, getCompressionState } from "@/stores/compression-store";
import { toast } from "sonner";
import { useLocation } from "react-router-dom";

export function useCompressionNotification() {
  const { pathname } = useLocation();
  const prevPhaseRef = useRef(getCompressionState().phase);

  useEffect(() => {
    const unsub = subscribeCompression(() => {
      const { phase, error } = getCompressionState();
      const prevPhase = prevPhaseRef.current;
      prevPhaseRef.current = phase;

      // Ne notifier que si l'utilisateur n'est pas sur la page médias
      // (sur /media le dialog est déjà visible)
      if (pathname === "/media") return;

      if (prevPhase === "compressing" && phase === "done") {
        toast.success("Vidéo compressée", {
          description: "L'upload démarre automatiquement.",
          duration: 4000,
        });
      }

      if (prevPhase !== "error" && phase === "error") {
        toast.error("Compression échouée", {
          description: error ?? "Réduisez la vidéo manuellement avant de l'uploader.",
          duration: 6000,
        });
      }
    });

    return unsub;
  }, [pathname]);
}
